import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { setProfileUser } from "../../../store/user/actions";
import { Building2, FileText } from 'lucide-react';
import "./company-selector-asesor.scss";

interface CompanySelectorAsesorProps {
  onCompanyChange?: (companyId: string) => void;
}

const CompanySelectorAsesor: React.FC<CompanySelectorAsesorProps> = ({ onCompanyChange }) => {
  const dispatch = useDispatch();
  const profile = useSelector((state: RootState) => state.user);
  const { currentCompany, companies, currentRole } = profile;
  
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>(
    currentCompany?.id || (companies && companies[0]?.id) || ""
  );

  // Actualizar selectedCompanyId cuando cambie currentCompany
  useEffect(() => {
    if (currentCompany?.id) {
      setSelectedCompanyId(currentCompany.id);
    }
  }, [currentCompany]);

  const handleCompanyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const companyId = e.target.value;
    const selectedCompany = companies?.find((c: any) => c.id === companyId);
    
    if (selectedCompany) {
      setSelectedCompanyId(companyId);
      
      // Actualizar Redux con la nueva compañía seleccionada
      const updatedProfile = {
        ...profile,
        currentCompany: selectedCompany,
      };
      
      dispatch(setProfileUser(updatedProfile));
      
      // Llamar callback si existe
      if (onCompanyChange) {
        onCompanyChange(companyId);
      }
      
      // Recargar la página para actualizar el navbar
      setTimeout(() => window.location.reload(), 300);
    }
  };

  const getSelectedCompany = () => {
    return companies?.find((c: any) => c.id === selectedCompanyId);
  };

  // Solo mostrar el selector para el rol ASESOR
  if (currentRole !== "ASESOR") {
    return null;
  }

  return (
    <div className="company-selector-container mb-4">
      <div className="company-selector-banner">
        <div className="banner-gradient"></div>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-auto">
              <div className="banner-icon-container">
                <div className="banner-icon">
                  <Building2 size={24} strokeWidth={2} />
                </div>
                <div className="icon-glow"></div>
              </div>
            </div>

            <div className="col">
              <div className="company-selector-content">
                <label htmlFor="company-selector-asesor" className="company-selector-label">
                  Seleccionar Compañía:
                </label>
                <select
                  id="company-selector-asesor"
                  className="company-selector-select"
                  value={selectedCompanyId}
                  onChange={handleCompanyChange}
                >
                  {companies && companies.length > 0 ? (
                    companies.map((company: any) => (
                      <option key={company.id} value={company.id}>
                        {company.socialReason} - Cliente: #{company.managerId}
                      </option>
                    ))
                  ) : (
                    <option value="">No hay compañías disponibles</option>
                  )}
                </select>
              </div>
            </div>

            <div className="col-auto d-none d-lg-block">
              <div className="banner-features">
                <div className="feature-item">
                  <FileText size={16} />
                  <span>{getSelectedCompany()?.companyType}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySelectorAsesor;

